import { Component, Fragment, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import Footerwithdr from "../../../common_components/Footerwithdr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getVendorAuditTrackerList_action } from "../../../actions/admin_module_action/preSetupTracker_action/vendorView_action";
import {
  updateVendorPlan_action,
  getVendorPlanDetail_action,
} from "../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_plan_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import {
  ATTACHMENT_ACTION_ADD,
  ATTACHMENT_ACTION_REMOVE,
  MAX_ATTACHMENTS,
  capAttachments,
  extractAttachmentRows,
  getAttachmentName,
  getAttachmentUrl,
  normalizeAttachmentRow,
  pickAttachmentFile,
} from "../../../utils/vendor_attachment_helper";
import {
  formatServerDateTime,
  serverDateTimeValue,
} from "../../../utils/vendor_datetime_helper";
import moment from "moment";
import Modal from "react-modal";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class VendorPlanRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
      subPointDetails: {}, // Track sub-points for each deliverable
      originalSubPoints: {}, // Track original sub-points from API
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17,
      StartDate: null,
      EndDate: null,
      StartDateErr: "",
      ExhVendorPlanHdrID: null,
      isReadonly: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 ? false : sessionStorage.getItem("vendorPlanReadonly") === "true",
      PlanSubmissionDate: "",
      workOrderNo: sessionStorage.getItem("selectedWorkOrderNo") || "",
      serviceName: sessionStorage.getItem("selectedServiceName") || "",
      // Nothing carries the service partner's name into this screen, so it is
      // read off the plan itself once the detail call answers
      CompanyName: "",
      showConfirmModal: false,
      pendingAction: null,
      showStartTimeModal: false,
      pendingStartTime: null,
      pendingRowIndex: null,
      pendingHallName: null,
      showEndTimeModal: false,
      pendingEndTime: null,
      pendingSubPointId: null,
      showManagerModal: false,
      modalManagers: [],
      modalHallName: "",
      modalServiceName: "",
      expandedDeliverable: null,
      expandedHall: null,
      remarkSource: [], // Flat remark rows as they come from the API
      remarkDetails: {}, // Chat threads keyed by deliverable / sub-point
      showRemarkModal: false,
      activeRemarkKey: null,
      activeRemarkTitle: "",
      newRemark: "",
      attachmentDetails: {}, // Live attachments keyed by deliverable / sub-point
      removedAttachments: [], // Stored attachments the user removed, not saved yet
      showAttachmentModal: false,
      activeAttachmentKey: null,
      activeAttachmentTitle: "",
      activeAttachmentTarget: null,
    };

    this.transformVendorPlanData = this.transformVendorPlanData.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);
    this.updateVendorTime = this.updateVendorTime.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");

    // Get ExhVendorPlanHdrID from URL params or session storage
    const urlParams = new URLSearchParams(window.location.search);
    const ExhVendorPlanHdrID =
      urlParams.get("id") || sessionStorage.getItem("selectedVendorPlanId");

    if (ExhVendorPlanHdrID) {
      this.setState({ ExhVendorPlanHdrID });
      this.loadPlanDetails(ExhVendorPlanHdrID);
      this.startRemarkPolling();
    }
  }

  componentWillUnmount() {
    this.stopRemarkPolling();
  }

  // Several people work one plan, so remarks and files posted elsewhere have to
  // appear here on their own. Only those are refreshed, never the grid
  startRemarkPolling() {
    this.stopRemarkPolling();
    this.remarkPollingTimer = setInterval(() => {
      if (document.hidden) return;
      this.refreshRemarksAndAttachments();
    }, 20000);
  }

  stopRemarkPolling() {
    if (this.remarkPollingTimer) {
      clearInterval(this.remarkPollingTimer);
      this.remarkPollingTimer = null;
    }
  }

  // Pulls the plan from the API and lays out the grid, the sub points, the
  // remarks and the attachments. Called on load and again after an attachment is
  // stored, so the saved file comes back with its ExhPlanAttachmentDtlID
  loadPlanDetails(ExhVendorPlanHdrID) {
    return this.props
      .getVendorPlanDetail_action(ExhVendorPlanHdrID)
      .then((response) => {
        if (response.error === 0 && response.data?.vendorPlanDetails) {
          // Directly use the API response data
          const { halls, grid } = this.transformData(
            response.data.vendorPlanDetails
          );

          // Load existing sub-points from API response
          // SubPoint field is within vendorPlanDetails items
          const subPointDetails = {};
          const originalSubPoints = {};

          response.data.vendorPlanDetails.forEach((item) => {
            if (item.SubPoint && item.SubPoint.trim()) {
              // Find which row this sub-point belongs to by matching ExhVendorPlanDtlID
              const rowIndex = grid.findIndex((row) => {
                return Object.values(row).some((hallData) => {
                  return hallData?.vendors?.some(
                    (v) => v.ExhVendorPlanDtlID === item.ExhVendorPlanDtlID
                  );
                });
              });

              if (rowIndex !== -1) {
                const key = `row_${rowIndex}`;

                if (!subPointDetails[key]) {
                  subPointDetails[key] = [];
                }

                // The same sub-point can arrive once per hall - merge them into a
                // single row that carries per hall timings
                let subPointObj = subPointDetails[key].find(
                  (sp) => sp.SubPoint === item.SubPoint
                );

                if (!subPointObj) {
                  subPointObj = {
                    id: `subpoint_${item.ExhVendorPointDtlID || Date.now()}_${Math.random()}`,
                    ExhVendorPointDtlID: item.ExhVendorPointDtlID || null,
                    SubPoint: item.SubPoint,
                    isNew: false,
                    times: {},
                  };
                  subPointDetails[key].push(subPointObj);
                }

                if (item.HallName) {
                  subPointObj.times[item.HallName] = {
                    ExhVendorPointDtlID: item.ExhVendorPointDtlID || null,
                    StartTime: item.StartDateTime || null,
                    EndTime: item.EndDateTime || null,
                  };
                }
              }
            }
          });

          // Store a deep copy of the originals for delete tracking
          Object.keys(subPointDetails).forEach((key) => {
            originalSubPoints[key] = subPointDetails[key].map((sp) => ({
              ...sp,
              times: { ...sp.times },
            }));
          });

          const remarkSource = this.extractRemarkRows(response.data);

          this.setState({
            halls,
            grid,
            subPointDetails,
            originalSubPoints,
            remarkSource,
            attachmentDetails: this.buildAttachmentMap(
              grid,
              subPointDetails,
              extractAttachmentRows(response.data)
            ),
            removedAttachments: [],
            remarkDetails: this.buildRemarkThreads(
              grid,
              subPointDetails,
              remarkSource
            ),
            PlanSubmissionDate: this.getPlanSubmissionDate(
              response.data.vendorPlanDetails
            ),
            CompanyName: this.getPlanCompanyName(
              response.data.vendorPlanDetails
            ),
          });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.vendorPlanDetails !== this.props.vendorPlanDetails &&
      this.props.vendorPlanDetails.length > 0
    ) {
      this.transformVendorPlanData();
    }
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  transformVendorPlanData() {
    const vendorPlanDetails = this.props.vendorPlanDetails || [];
    console.log(
      "vendorPlanDetails in transformVendorPlanData:",
      vendorPlanDetails
    );

    if (vendorPlanDetails.length === 0) {
      this.setState({ halls: [], grid: [] });
      return;
    }

    const { halls, grid } = this.transformData(vendorPlanDetails);
    this.setState({
      halls,
      grid,
      remarkDetails: this.buildRemarkThreads(grid, this.state.subPointDetails),
      PlanSubmissionDate: this.getPlanSubmissionDate(vendorPlanDetails),
      CompanyName: this.getPlanCompanyName(vendorPlanDetails),
    });
  }

  // The submission due date is the same for the whole plan, so the first
  // record that carries it is used
  getPlanSubmissionDate(apiData) {
    return (
      (apiData || []).find((item) => item.PlanSubmissionDate)
        ?.PlanSubmissionDate || ""
    );
  }

  // A plan belongs to one service partner, so every row repeats the same
  // CompanyName - the first one that carries it is used
  getPlanCompanyName(apiData) {
    return (apiData || []).find((item) => item.CompanyName)?.CompanyName || "";
  }

  // Plan submission due date shown on top of the plan - DD-MM-YYYY HH:mm
  formatSubmissionDate(dateString) {
    if (!dateString) return null;
    const date = moment.utc(dateString);
    return date.isValid() ? date.format("DD-MM-YYYY HH:mm") : null;
  }

  transformData(apiData) {
    const halls = [...new Set(apiData.map((item) => item.HallName))];
    const services = [
      ...new Set(apiData.map((item) => item.DeliverablesServiceName)),
    ];

    const grid = services.map((service) => {
      const row = { service };
      halls.forEach((hall) => {
        const records = apiData.filter(
          (d) => d.DeliverablesServiceName === service && d.HallName === hall
        );
        if (records.length > 0) {
          // Use StartTime and EndTime from first record for the hall
          row[hall] = {
            StartTime: records[0].StartTime,
            EndTime: records[0].EndTime,
            vendors: records
          };
        } else {
          row[hall] = { StartTime: null, EndTime: null, vendors: [] };
        }
      });
      return row;
    });

    return { halls, grid };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
        StartDate: null,
        EndDate: null,
        StartDateErr: "",
      },
      () => this.transformVendorPlanData()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  handleCancel = () => {
    sessionStorage.removeItem("vendorPlanReadonly");
    sessionStorage.removeItem("selectedWorkOrderNo");
    sessionStorage.removeItem("selectedServiceName");
    if (this.props.onNavigateBack) {
      this.props.onNavigateBack();
    } else if (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6) {
      this.props.navigate("/VendorPlan");
    } else {
      this.props.navigate("/VendorModule");
    }
  };

  updateVendorTime(rowIndex, hallName, field, value) {
    const { grid } = this.state;
    const updatedGrid = [...grid];
    updatedGrid[rowIndex][hallName] = {
      ...updatedGrid[rowIndex][hallName],
      [field]: value
    };
    this.setState({ grid: updatedGrid });
  }

  // Parent deliverable timings for a hall cell - sub points must stay inside these
  getParentTimes = (rowIndex, hallName) => this.state.grid[rowIndex]?.[hallName] || null;

  // A sub point date time is valid only when it sits inside the parent deliverable range
  isWithinParentRange = (rowIndex, hallName, value) => {
    if (!value) return true;

    const parent = this.getParentTimes(rowIndex, hallName);
    const parentStart = parent?.StartTime ? new Date(parent.StartTime) : null;
    const parentEnd = parent?.EndTime ? new Date(parent.EndTime) : null;
    const date = new Date(value);

    if (parentStart && date < parentStart) return false;
    if (parentEnd && date > parentEnd) return false;
    return true;
  }

  // Copies a sub-point timing across every hall column of that sub-point row,
  // skipping halls where the value falls outside that hall's deliverable timing
  applySubPointTimeToAllHalls = (field, value) => {
    const { subPointDetails, pendingRowIndex, pendingSubPointId, halls } = this.state;
    const key = `row_${pendingRowIndex}`;
    const skippedHalls = [];

    const updated = (subPointDetails[key] || []).map((sp) => {
      if (sp.id !== pendingSubPointId) return sp;
      const times = { ...(sp.times || {}) };
      halls.forEach((hall) => {
        if (!this.isWithinParentRange(pendingRowIndex, hall, value)) {
          skippedHalls.push(hall);
          return;
        }
        times[hall] = { ...(times[hall] || {}), [field]: value };
      });
      return { ...sp, times };
    });

    if (skippedHalls.length > 0) {
      toastError(
        `Date time not applied for ${skippedHalls.join(", ")} as it falls outside the timing of ${pendingRowIndex + 1}`
      );
    }

    return { ...subPointDetails, [key]: updated };
  }

  applyStartTimeToRow = () => {
    const { grid, pendingStartTime, pendingRowIndex, pendingSubPointId, halls } = this.state;

    if (pendingSubPointId) {
      this.setState({
        subPointDetails: this.applySubPointTimeToAllHalls("StartTime", pendingStartTime),
        showStartTimeModal: false,
        pendingStartTime: null,
        pendingRowIndex: null,
        pendingHallName: null,
        pendingSubPointId: null,
      });
      return;
    }

    const updatedGrid = [...grid];

    halls.forEach((hall) => {
      if (updatedGrid[pendingRowIndex][hall]) {
        updatedGrid[pendingRowIndex][hall].StartTime = pendingStartTime;
      }
    });

    this.setState({
      grid: updatedGrid,
      showStartTimeModal: false,
      pendingStartTime: null,
      pendingRowIndex: null,
      pendingHallName: null,
      pendingSubPointId: null
    });
  }

  cancelStartTimeModal = () => {
    this.setState({
      showStartTimeModal: false,
      pendingStartTime: null,
      pendingRowIndex: null,
      pendingHallName: null,
      pendingSubPointId: null
    });
  }

  applyEndTimeToRow = () => {
    const { grid, pendingEndTime, pendingRowIndex, pendingSubPointId, halls } = this.state;

    if (pendingSubPointId) {
      this.setState({
        subPointDetails: this.applySubPointTimeToAllHalls("EndTime", pendingEndTime),
        showEndTimeModal: false,
        pendingEndTime: null,
        pendingRowIndex: null,
        pendingHallName: null,
        pendingSubPointId: null,
      });
      return;
    }

    const updatedGrid = [...grid];

    halls.forEach((hall) => {
      if (updatedGrid[pendingRowIndex][hall]) {
        updatedGrid[pendingRowIndex][hall].EndTime = pendingEndTime;
      }
    });

    this.setState({
      grid: updatedGrid,
      showEndTimeModal: false,
      pendingEndTime: null,
      pendingRowIndex: null,
      pendingHallName: null,
      pendingSubPointId: null
    });
  }

  cancelEndTimeModal = () => {
    this.setState({
      showEndTimeModal: false,
      pendingEndTime: null,
      pendingRowIndex: null,
      pendingHallName: null,
      pendingSubPointId: null
    });
  }

  openManagerModal = (managers, hallName, serviceName) => {
    this.setState({
      showManagerModal: true,
      modalManagers: managers,
      modalHallName: hallName,
      modalServiceName: serviceName,
    });
  }

  closeManagerModal = () => {
    this.setState({
      showManagerModal: false,
      modalManagers: [],
      modalHallName: "",
      modalServiceName: "",
    });
  }

  // Shared start/end checks - getTimes() must read the latest state,
  // reset(field) clears the offending value, getParent() (sub points only)
  // returns the deliverable timings the value has to stay inside
  validateTimes = (getTimes, field, reset, getParent, parentNo) => {
    setTimeout(() => {
      const times = getTimes();
      if (!times) return;

      const now = new Date();
      const startTime = times.StartTime ? new Date(times.StartTime) : null;
      const endTime = times.EndTime ? new Date(times.EndTime) : null;

      const parent = getParent ? getParent() : null;
      const parentStart = parent?.StartTime ? new Date(parent.StartTime) : null;
      const parentEnd = parent?.EndTime ? new Date(parent.EndTime) : null;

      if (field === "StartTime" && startTime) {
        // A parent range can already be in the past, then it drives the limits
        if (!parentStart && !parentEnd && startTime < now) {
          toastError("Start date time cannot be less than current date time");
          reset("StartTime");
          return;
        }
        if (parentStart && startTime < parentStart) {
          toastError(
            `Start date time cannot be before the start date time of ${parentNo}`
          );
          reset("StartTime");
          return;
        }
        if (parentEnd && startTime > parentEnd) {
          toastError(
            `Start date time cannot be after the end date time of ${parentNo}`
          );
          reset("StartTime");
          return;
        }
      }

      if (field === "EndTime" && endTime) {
        if (startTime && endTime.getTime() === startTime.getTime()) {
          toastError("End date time cannot be same as start date time");
          reset("EndTime");
          return;
        }
        if (parentEnd && endTime > parentEnd) {
          toastError(
            `End date time cannot be after the end date time of ${parentNo}`
          );
          reset("EndTime");
          return;
        }
        if (parentStart && endTime < parentStart) {
          toastError(
            `End date time cannot be before the start date time of ${parentNo}`
          );
          reset("EndTime");
          return;
        }
      }
    }, 100);
  };

  validateDateTime = (rowIndex, hallName, field) => {
    this.validateTimes(
      () => this.state.grid[rowIndex]?.[hallName],
      field,
      (f) => this.updateVendorTime(rowIndex, hallName, f, null)
    );
  };

  validateSubPointDateTime = (rowIndex, subPointId, hallName, field) => {
    this.validateTimes(
      () =>
        this.state.subPointDetails[`row_${rowIndex}`]?.find(
          (sp) => sp.id === subPointId
        )?.times?.[hallName],
      field,
      (f) => this.updateSubPointTime(rowIndex, subPointId, hallName, f, null),
      () => this.getParentTimes(rowIndex, hallName),
      `${rowIndex + 1}`
    );
  };

  updateSubPointTime = (rowIndex, subPointId, hallName, field, value) => {
    const { subPointDetails } = this.state;
    const key = `row_${rowIndex}`;
    const updated = (subPointDetails[key] || []).map((sp) => {
      if (sp.id !== subPointId) return sp;
      return {
        ...sp,
        times: {
          ...(sp.times || {}),
          [hallName]: { ...(sp.times?.[hallName] || {}), [field]: value },
        },
      };
    });

    this.setState({
      subPointDetails: { ...subPointDetails, [key]: updated },
    });
  };

  addSubPoint = (rowIndex) => {
    const { subPointDetails } = this.state;
    const key = `row_${rowIndex}`;
    const newSubPoint = {
      id: `subpoint_${Date.now()}_${Math.random()}`,
      SubPoint: "",
      isNew: true,
      times: {},
    };

    this.setState({
      subPointDetails: {
        ...subPointDetails,
        [key]: [...(subPointDetails[key] || []), newSubPoint],
      }
    }, () => {
      // Focus the row that was just added
      const textarea = document.querySelector(
        `textarea[data-subpoint-id="${newSubPoint.id}"]`
      );
      if (textarea) {
        textarea.focus();
        textarea.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
    });
  };

  updateSubPoint = (rowIndex, subPointId, value) => {
    const { subPointDetails } = this.state;
    const key = `row_${rowIndex}`;
    const updated = subPointDetails[key]?.map((sp) =>
      sp.id === subPointId ? { ...sp, SubPoint: value } : sp
    ) || [];

    this.setState({
      subPointDetails: {
        ...subPointDetails,
        [key]: updated,
      }
    });
  };

  removeSubPoint = (rowIndex, subPointId) => {
    const { subPointDetails } = this.state;
    const key = `row_${rowIndex}`;
    const updated = subPointDetails[key]?.filter((sp) => sp.id !== subPointId) || [];

    this.setState({
      subPointDetails: {
        ...subPointDetails,
        [key]: updated.length > 0 ? updated : undefined,
      }
    });
  };

  // One remark thread per deliverable row, one more per sub point of that row
  getRemarkKey = (rowIndex, subPointId) =>
    subPointId ? `row_${rowIndex}_sub_${subPointId}` : `row_${rowIndex}`;

  // Remarks come back as their own result set, so pull whichever key of the
  // detail response carries that list
  extractRemarkRows(data) {
    if (!data) return [];
    const candidates = [
      data.remarkList,
      data.remarkDetails,
      data.vendorPlanRemarks,
      Array.isArray(data) ? data[1] : null,
    ];
    return candidates.find((list) => Array.isArray(list)) || [];
  }

  // One API row is one posted message. The result set used to carry the
  // deliverable's latest text and a log row's text side by side under Remark /
  // RemarkSub, which is why a row could expand into two messages - it no longer
  // does, but a row in the old shape is still read so the screen works against
  // either version
  normalizeRemarkRow(row) {
    const authorId = row.UserID ?? row.LastUpdatedBy ?? null;

    const base = {
      RemarkID: row.RemarkID ?? null,
      WorkOrderDeliverablesID: row.WorkOrderDeliverablesID,
      ExhVendorPlanDtlID: row.ExhVendorPlanDtlID,
      ExhVendorPointDtlID: row.ExhVendorPointDtlID ?? null,
      SubPoint: row.SubPoint ?? null,
      DeliverablesServiceName: row.DeliverablesServiceName ?? null,
      // UserID is what separates own messages from everyone else's, the name is
      // only a fallback for when the API leaves the id out
      // A 0 or an empty string is not a usable id, don't let it beat the name
      LastUpdatedBy: authorId === 0 || authorId === "" ? null : authorId,
      // Can arrive as blank or a lone space, treat that as no name at all
      PersonName: String(row.UserName ?? row.PersonName ?? "").trim(),
      Designation: row.Role ?? row.Designation ?? "",
      LastUpdatedDate: row.UpdateTime ?? row.LastUpdatedDate ?? null,
    };

    const deliverableText = row.Remark && String(row.Remark).trim();
    const subPointText = row.RemarkSub && String(row.RemarkSub).trim();

    // The API says which thread the message belongs to. Falling back to the point
    // id keeps rows in the old shape readable
    const isSubPoint =
      row.IsSubPoint != null
        ? row.IsSubPoint === true || row.IsSubPoint === 1
        : row.ExhVendorPointDtlID != null;

    const messages = [];
    if (deliverableText) {
      messages.push({ ...base, Remark: deliverableText, isSubPoint });
    }
    if (subPointText && subPointText !== deliverableText) {
      messages.push({
        ...base,
        Remark: subPointText,
        isSubPoint: row.ExhVendorPointDtlID != null,
      });
    }

    return messages;
  }

  // Flat remark rows get matched back to their thread through the ids already
  // on the grid - the deliverable by WorkOrderDeliverablesID / ExhVendorPlanDtlID
  // and the sub point by ExhVendorPointDtlID, falling back to the sub point text
  buildRemarkThreads(grid, subPointDetails, remarkRows = this.state.remarkSource) {
    const threads = {};

    const rowByDeliverableId = {};
    const rowByPlanDtlId = {};
    const rowByService = {};
    const threadByPointDtlId = {};

    grid.forEach((row, rowIndex) => {
      if (row.service) rowByService[row.service] = rowIndex;

      Object.keys(row).forEach((hall) => {
        (row[hall]?.vendors || []).forEach((vendor) => {
          if (vendor.WorkOrderDeliverablesID != null) {
            rowByDeliverableId[vendor.WorkOrderDeliverablesID] = rowIndex;
          }
          if (vendor.ExhVendorPlanDtlID != null) {
            rowByPlanDtlId[vendor.ExhVendorPlanDtlID] = rowIndex;
          }
        });
      });

      // A sub point holds one point id per hall, any of them identifies the thread
      (subPointDetails[`row_${rowIndex}`] || []).forEach((sp) => {
        const thread = { rowIndex, subPointId: sp.id };
        if (sp.ExhVendorPointDtlID != null) {
          threadByPointDtlId[sp.ExhVendorPointDtlID] = thread;
        }
        Object.values(sp.times || {}).forEach((time) => {
          if (time?.ExhVendorPointDtlID != null) {
            threadByPointDtlId[time.ExhVendorPointDtlID] = thread;
          }
        });
      });
    });

    let unresolvedSubPoints = 0;
    let unresolvedDeliverables = 0;

    const placeMessage = (remark) => {
      // The plan detail id names one row of the grid, the deliverable id can be
      // shared, so the precise one is tried first
      const rowIndex =
        rowByPlanDtlId[remark.ExhVendorPlanDtlID] ??
        rowByDeliverableId[remark.WorkOrderDeliverablesID] ??
        rowByService[remark.DeliverablesServiceName];

      let key = null;

      if (remark.isSubPoint) {
        // A sub point message has to say which of 1.1 / 1.2 / ... it belongs to
        const pointThread =
          remark.ExhVendorPointDtlID != null
            ? threadByPointDtlId[remark.ExhVendorPointDtlID]
            : null;

        if (pointThread) {
          key = this.getRemarkKey(pointThread.rowIndex, pointThread.subPointId);
        } else if (rowIndex != null && remark.SubPoint) {
          const subPoint = (subPointDetails[`row_${rowIndex}`] || []).find(
            (sp) => sp.SubPoint === remark.SubPoint
          );
          if (subPoint) key = this.getRemarkKey(rowIndex, subPoint.id);
        }

        // Better to leave it out than to show it under the wrong sub point
        if (!key) {
          unresolvedSubPoints++;
          return;
        }
      } else {
        // Nothing on the row ties it to a deliverable in the grid
        if (rowIndex == null) {
          unresolvedDeliverables++;
          return;
        }
        key = this.getRemarkKey(rowIndex);
      }

      if (!threads[key]) threads[key] = [];

      // Every message now carries its own RemarkID, so two people posting the same
      // words both show. Only a row in the old shape, which has no id, still has to
      // fall back to the text
      const alreadyAdded = threads[key].some((r) =>
        remark.RemarkID != null
          ? r.RemarkID === remark.RemarkID
          : r.RemarkID == null && r.Remark === remark.Remark
      );
      if (!alreadyAdded) threads[key].push({ ...remark });
    };

    // A single row can hold a deliverable message and a sub point message
    (remarkRows || []).forEach((row) =>
      this.normalizeRemarkRow(row).forEach(placeMessage)
    );

    if (unresolvedDeliverables > 0) {
      console.warn(
        `[remark] ${unresolvedDeliverables} deliverable remark(s) dropped - WorkOrderDeliverablesID / ExhVendorPlanDtlID on the row match no deliverable in the grid`
      );
    }

    if (unresolvedSubPoints > 0) {
      console.warn(
        `[remark] ${unresolvedSubPoints} sub point remark(s) dropped - the row carries no ExhVendorPointDtlID or SubPoint to tie it to a sub point`
      );
    }

    // Only a message that has not reached the API yet is carried over. Matching a
    // saved local copy against the one that came back used to decide this, and
    // when the two names did not line up exactly the same message showed twice -
    // once from this browser and once from the server. A saved message is dropped
    // outright now and the server's copy is the only one
    const currentThreads = this.state.remarkDetails || {};
    Object.keys(currentThreads).forEach((key) => {
      const pending = currentThreads[key].filter((r) => r.isPending);
      if (pending.length > 0) {
        threads[key] = [...(threads[key] || []), ...pending];
      }
    });

    // Oldest first so the thread reads like a chat. Read the same way it is
    // printed, otherwise a message that has not been saved yet - which carries no
    // zone marker - sorts against the saved ones by a different clock
    Object.keys(threads).forEach((key) => {
      threads[key].sort(
        (a, b) =>
          serverDateTimeValue(a.LastUpdatedDate) -
          serverDateTimeValue(b.LastUpdatedDate)
      );
    });

    return threads;
  }

  openRemarkModal = (rowIndex, subPointId, title) => {
    this.setState({
      showRemarkModal: true,
      activeRemarkKey: this.getRemarkKey(rowIndex, subPointId),
      activeRemarkTitle: title,
      newRemark: "",
    });
  };

  closeRemarkModal = () => {
    this.setState({
      showRemarkModal: false,
      activeRemarkKey: null,
      activeRemarkTitle: "",
      newRemark: "",
    });
  };

  // Everybody who can open the plan can post - the message shows in the thread
  // straight away and is sent on its own, without waiting for the plan save
  addRemark = () => {
    const { newRemark, activeRemarkKey, remarkDetails } = this.state;
    const text = (newRemark || "").trim();

    if (!text) {
      toastError("Please enter a note/remark");
      return;
    }

    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
    const entry = {
      Remark: text,
      LastUpdatedBy: loginData.UserID,
      PersonName: [loginData.FirstName, loginData.LastName]
        .filter(Boolean)
        .join(" "),
      // No zone marker, so it reads back as the local time it was typed at. The
      // saved copy replaces this the moment the API answers
      LastUpdatedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      isPending: true,
    };

    this.setState(
      {
        remarkDetails: {
          ...remarkDetails,
          [activeRemarkKey]: [...(remarkDetails[activeRemarkKey] || []), entry],
        },
        newRemark: "",
      },
      () => {
        this.scrollRemarkThreadToBottom();
        this.saveRemark();
      }
    );
  };

  // The plan is worked by the service partner and by the operations team at the
  // same time, so the threads and the files have to keep arriving without a
  // reload. Only those parts of the state are replaced - the grid, the sub points
  // and the timings are left exactly as they are, because they may hold edits the
  // user has not saved yet
  refreshRemarksAndAttachments = () => {
    const ExhVendorPlanHdrID = this.state.ExhVendorPlanHdrID;
    if (!ExhVendorPlanHdrID) return Promise.resolve();

    return this.props
      .getVendorPlanDetail_action(ExhVendorPlanHdrID)
      .then((response) => {
        if (response.error !== 0 || !response.data?.vendorPlanDetails) return;

        const { grid, subPointDetails } = this.state;
        const remarkSource = this.extractRemarkRows(response.data);
        const stored = this.buildAttachmentMap(
          grid,
          subPointDetails,
          extractAttachmentRows(response.data)
        );

        // A file picked but not submitted yet is only in this browser, it has to
        // survive the refresh
        const { attachmentDetails } = this.state;
        Object.keys(attachmentDetails).forEach((key) => {
          const pending = (attachmentDetails[key] || []).filter((a) => a.isNew);
          if (pending.length > 0) {
            stored[key] = capAttachments([...(stored[key] || []), ...pending]);
          }
        });

        this.setState({
          remarkSource,
          remarkDetails: this.buildRemarkThreads(
            grid,
            subPointDetails,
            remarkSource
          ),
          attachmentDetails: stored,
        });
      })
      .catch((err) => console.log("[remark] background refresh failed:", err));
  };

  // Sends the same full payload the plan save builds, so the API always sees a
  // complete plan - only the flags differ, this is always a plain update and
  // never an approve or a draft
  saveRemark = () => {
    const {
      planDetails,
      subPointsArray,
      validationError,
      ExhVendorHdrID,
      ExhibitionID,
    } = this.buildPlanPayload({ includeAttachments: false });

    if (!ExhVendorHdrID) {
      toastError("Service Partner Plan ID not found!");
      return;
    }

    // A date problem elsewhere in the plan must not stop someone commenting,
    // the rows go over as they already are
    if (validationError) {
      console.warn("[remark] saving remark with plan warning:", validationError);
    }

    const isAdmin =
      JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 ? 1 : 0;

    this.setState({ isLoading: true });

    this.props
      .updateVendorPlan_action(
        ExhVendorHdrID,
        ExhibitionID,
        0,
        0,
        planDetails,
        subPointsArray,
        [],
        isAdmin,
        // Stores the message only - an approved plan must not drop back to
        // submitted because somebody left a comment on it
        true
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Notes/Remark added successfully!");
          // The payload carries every pending message, not only the one just
          // typed, so all of them are saved now. They are removed rather than
          // just unmarked - the refresh below brings each one back as the
          // server's own copy, with its real author and time, and keeping the
          // local one would show the same message twice
          this.setState(
            (prev) => {
              const remarkDetails = {};
              Object.keys(prev.remarkDetails).forEach((threadKey) => {
                remarkDetails[threadKey] = prev.remarkDetails[threadKey].filter(
                  (r) => !r.isPending
                );
              });
              return { remarkDetails };
            },
            // Pull the thread back so the saved copy, and anything posted by
            // someone else in the meantime, both show
            () =>
              this.refreshRemarksAndAttachments().then(() =>
                // The saved copy replaces the local one, so the thread is
                // re-rendered - hold it at the newest message
                this.setState({ isLoading: false }, () =>
                  this.scrollRemarkThreadToBottom()
                )
              )
          );
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  // Only what was added in this session goes to the API, the rest is already saved
  getPendingRemarkText = (rowIndex, subPointId) => {
    const thread =
      this.state.remarkDetails[this.getRemarkKey(rowIndex, subPointId)] || [];
    const pending = thread.filter((r) => r.isPending).map((r) => r.Remark);
    return pending.length > 0 ? pending.join("\n") : null;
  };

  // Attachments hang off the same deliverable / sub point threads as remarks, so
  // they are keyed the same way
  // Stored attachments get matched back to their row through the ids already on
  // the grid - the deliverable by ExhVendorPlanDtlID and the sub point by
  // ExhVendorPointDtlID
  buildAttachmentMap(grid, subPointDetails, attachmentRows) {
    const attachments = {};

    const rowByPlanDtlId = {};
    const threadByPointDtlId = {};

    grid.forEach((row, rowIndex) => {
      Object.keys(row).forEach((hall) => {
        (row[hall]?.vendors || []).forEach((vendor) => {
          if (vendor.ExhVendorPlanDtlID != null) {
            rowByPlanDtlId[vendor.ExhVendorPlanDtlID] = rowIndex;
          }
        });
      });

      // A sub point holds one point id per hall, any of them identifies the row
      (subPointDetails[`row_${rowIndex}`] || []).forEach((sp) => {
        const thread = { rowIndex, subPointId: sp.id };
        if (sp.ExhVendorPointDtlID != null) {
          threadByPointDtlId[sp.ExhVendorPointDtlID] = thread;
        }
        Object.values(sp.times || {}).forEach((time) => {
          if (time?.ExhVendorPointDtlID != null) {
            threadByPointDtlId[time.ExhVendorPointDtlID] = thread;
          }
        });
      });
    });

    let unresolved = 0;

    (attachmentRows || []).forEach((row) => {
      const attachment = normalizeAttachmentRow(row);
      let key = null;

      if (attachment.ExhVendorPointDtlID != null) {
        const thread = threadByPointDtlId[attachment.ExhVendorPointDtlID];
        // Better to leave it out than to show it under the wrong sub point
        if (thread) key = this.getRemarkKey(thread.rowIndex, thread.subPointId);
      } else {
        const rowIndex = rowByPlanDtlId[attachment.ExhVendorPlanDtlID];
        if (rowIndex != null) key = this.getRemarkKey(rowIndex);
      }

      if (!key) {
        unresolved++;
        return;
      }

      if (!attachments[key]) attachments[key] = [];
      attachments[key].push(attachment);
    });

    if (unresolved > 0) {
      console.warn(
        `[attachment] ${unresolved} attachment(s) dropped - ExhVendorPlanDtlID / ExhVendorPointDtlID on the row match no deliverable or sub point in the grid`
      );
    }

    // Two slots per deliverable / sub point, whatever is stored beyond them stays
    // hidden
    Object.keys(attachments).forEach((key) => {
      attachments[key] = capAttachments(attachments[key]);
    });

    return attachments;
  }

  // The ids the API needs to store an attachment against. A deliverable spans
  // several halls but the attachment belongs to the deliverable, so it rides on
  // the first hall's row - the same rule remarks follow
  getAttachmentTarget = (rowIndex, subPointId) => {
    const { grid, halls, subPointDetails } = this.state;
    const row = grid[rowIndex] || {};

    let ExhVendorPlanDtlID = null;
    halls.some((hall) => {
      const vendor = (row[hall]?.vendors || [])[0];
      if (vendor && !vendor.isNew && vendor.ExhVendorPlanDtlID != null) {
        ExhVendorPlanDtlID = vendor.ExhVendorPlanDtlID;
        return true;
      }
      return false;
    });

    if (!subPointId) {
      return { ExhVendorPlanDtlID, ExhVendorPointDtlID: null };
    }

    const subPoint = (subPointDetails[`row_${rowIndex}`] || []).find(
      (sp) => sp.id === subPointId
    );

    const ExhVendorPointDtlID =
      subPoint?.ExhVendorPointDtlID ??
      Object.values(subPoint?.times || {}).find(
        (time) => time?.ExhVendorPointDtlID != null
      )?.ExhVendorPointDtlID ??
      null;

    return { ExhVendorPlanDtlID, ExhVendorPointDtlID };
  };

  // A row that was never saved has no id for the API to hang the file on
  canAttachTo = (rowIndex, subPointId) => {
    const target = this.getAttachmentTarget(rowIndex, subPointId);
    if (subPointId) return target.ExhVendorPointDtlID != null;
    return target.ExhVendorPlanDtlID != null;
  };

  openAttachmentModal = (rowIndex, subPointId, title) => {
    this.setState({
      showAttachmentModal: true,
      activeAttachmentKey: this.getRemarkKey(rowIndex, subPointId),
      activeAttachmentTitle: title,
      activeAttachmentTarget: { rowIndex, subPointId },
    });
  };

  closeAttachmentModal = () => {
    this.setState({
      showAttachmentModal: false,
      activeAttachmentKey: null,
      activeAttachmentTitle: "",
      activeAttachmentTarget: null,
    });
  };

  handleAttachmentPick = async (e) => {
    const { activeAttachmentKey, activeAttachmentTarget, attachmentDetails } =
      this.state;
    const input = e.target;
    const file = input.files?.[0];

    if (!file) return;
    input.value = "";

    const current = attachmentDetails[activeAttachmentKey] || [];

    if (current.length >= MAX_ATTACHMENTS) {
      toastError(
        `Only ${MAX_ATTACHMENTS} attachments are allowed - remove one to add another`
      );
      return;
    }

    if (
      !this.canAttachTo(
        activeAttachmentTarget.rowIndex,
        activeAttachmentTarget.subPointId
      )
    ) {
      toastError("Save the plan first, then add an attachment to this row");
      return;
    }

    const picked = await pickAttachmentFile(file);
    if (!picked) return;

    this.setState({
      attachmentDetails: {
        ...attachmentDetails,
        [activeAttachmentKey]: [
          ...current,
          {
            ...picked,
            id: `attachment_${Date.now()}_${Math.random()}`,
            ExhPlanAttachmentDtlID: null,
            isNew: true,
          },
        ],
      },
    });
  };

  // Anything picked or removed but not sent yet
  hasPendingAttachments = () => {
    const { attachmentDetails, removedAttachments } = this.state;
    return (
      removedAttachments.length > 0 ||
      Object.keys(attachmentDetails).some((key) =>
        (attachmentDetails[key] || []).some((attachment) => attachment.isNew)
      )
    );
  };

  // Attachments don't have to wait for the plan save - Submit sends them on
  // their own, through the same call, exactly like a remark does. The plan is
  // sent in full so nothing else on screen is lost, and it stays a plain update:
  // never an approve, never a draft
  saveAttachments = () => {
    const {
      planDetails,
      subPointsArray,
      attachmentsArray,
      validationError,
      ExhVendorHdrID,
      ExhibitionID,
    } = this.buildPlanPayload();

    if (attachmentsArray.length === 0) {
      toastError("No new attachment to submit");
      return;
    }

    if (!ExhVendorHdrID) {
      toastError("Service Partner Plan ID not found!");
      return;
    }

    // A date problem elsewhere in the plan must not stop someone attaching a
    // file, the rows go over as they already are
    if (validationError) {
      console.warn("[attachment] saving with plan warning:", validationError);
    }

    const isAdmin =
      JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 ? 1 : 0;

    this.setState({ isLoading: true });

    this.props
      .updateVendorPlan_action(
        ExhVendorHdrID,
        ExhibitionID,
        0,
        0,
        planDetails,
        subPointsArray,
        attachmentsArray,
        isAdmin,
        // Stores the file only - an approved plan must not drop back to submitted
        // because somebody attached a document to it
        true
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Attachment submitted successfully!");
          // The stored copy comes back with its id, so the local one goes
          this.loadPlanDetails(ExhVendorHdrID).then(() =>
            this.setState({ isLoading: false })
          );
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  // A stored file has to be removed through the API, one picked in this session
  // was never sent so it just goes
  removeAttachment = (index) => {
    const { activeAttachmentKey, attachmentDetails, removedAttachments } =
      this.state;
    const current = attachmentDetails[activeAttachmentKey] || [];
    const attachment = current[index];

    if (!attachment) return;

    this.setState({
      attachmentDetails: {
        ...attachmentDetails,
        [activeAttachmentKey]: current.filter((item, i) => i !== index),
      },
      removedAttachments: attachment.isNew
        ? removedAttachments
        : [...removedAttachments, attachment],
    });
  };

  // Everything the plan save has to send for attachments - the files picked in
  // this session and the stored ones that were removed
  getAttachmentDetailsForSubmit = () => {
    const { attachmentDetails, removedAttachments, grid, subPointDetails } =
      this.state;
    const rows = [];

    grid.forEach((row, rowIndex) => {
      const keys = [{ key: this.getRemarkKey(rowIndex), subPointId: null }];

      (subPointDetails[`row_${rowIndex}`] || []).forEach((sp) =>
        keys.push({
          key: this.getRemarkKey(rowIndex, sp.id),
          subPointId: sp.id,
        })
      );

      keys.forEach(({ key, subPointId }) => {
        (attachmentDetails[key] || [])
          .filter((attachment) => attachment.isNew)
          .forEach((attachment) => {
            const target = this.getAttachmentTarget(rowIndex, subPointId);
            rows.push({
              ExhPlanAttachmentDtlID: null,
              ExhVendorPlanDtlID: target.ExhVendorPlanDtlID,
              ExhVendorPointDtlID: target.ExhVendorPointDtlID,
              AttachmentFilePath: attachment.AttachmentFilePath,
              FileName: attachment.FileName,
              FileType: attachment.FileType,
              IsActive: 1,
              ActionID: ATTACHMENT_ACTION_ADD,
            });
          });
      });
    });

    removedAttachments.forEach((attachment) => {
      rows.push({
        ExhPlanAttachmentDtlID: attachment.ExhPlanAttachmentDtlID,
        ExhVendorPlanDtlID: attachment.ExhVendorPlanDtlID,
        ExhVendorPointDtlID: attachment.ExhVendorPointDtlID,
        AttachmentFilePath: attachment.AttachmentFilePath,
        FileName: attachment.FileName,
        FileType: attachment.FileType,
        IsActive: 0,
        ActionID: ATTACHMENT_ACTION_REMOVE,
      });
    });

    return rows;
  };

  // Attachment trigger - the count tells the user how many of the two slots are
  // taken without having to open the popup
  renderAttachmentButton(rowIndex, subPointId, title, className = "btn btn-sm btn-aqua-border", style = {}) {
    const count = (
      this.state.attachmentDetails[this.getRemarkKey(rowIndex, subPointId)] || []
    ).length;

    return (
      <button
        type="button"
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          this.openAttachmentModal(rowIndex, subPointId, title);
        }}
        style={{
          padding: "0.25rem 0.5rem",
          fontSize: "0.7rem",
          whiteSpace: "nowrap",
          ...style
        }}
        title="Attachments"
      >
        <i className="ri-attachment-2"></i>
        <span className="ms-1">
          Attach{count > 0 ? ` (${count}/${MAX_ATTACHMENTS})` : ""}
        </span>
      </button>
    );
  }

  // The row buttons are small and two of them carry only an icon, so the plan
  // header spells out what each one does. The samples are spans, not buttons -
  // they only have to look like the real thing
  renderButtonLegend() {
    const { isReadonly } = this.state;

    const sampleStyle = {
      padding: "0.25rem 0.5rem",
      fontSize: "0.7rem",
      whiteSpace: "nowrap",
      pointerEvents: "none",
    };

    const legend = [
      // Both of these only exist while the plan can still be edited
      ...(isReadonly
        ? []
        : [
          {
            sample: (
              <span className="btn btn-sm btn-outline-aqua" style={sampleStyle}>
                <i className="ri-add-line"></i>
              </span>
            ),
            text: "Add a sub deliverable",
          },
          {
            sample: (
              <span className="btn btn-sm btn-aqua" style={sampleStyle}>
                <i className="ri-delete-bin-line"></i>
              </span>
            ),
            text: "Option to remove sub deliverables",
          },
        ]),
      {
        sample: (
          <span className="btn btn-sm px-3 rounded-pill" style={{ ...sampleStyle, border: "1px solid #0f6f60", color: "#0f6f60", backgroundColor: "transparent", fontWeight: "500" }}>
            <i className="ri-message-3-line"></i>
            <span className="ms-1">Notes/Remark</span>
          </span>
        ),
        text: "Option to add multiple notes or remarks.",
      },
      {
        sample: (
          <span className="btn btn-sm px-3 rounded-pill" style={{ ...sampleStyle, border: "1px solid #0f6f60", color: "#0f6f60", backgroundColor: "transparent", fontWeight: "500" }}>
            <i className="ri-attachment-2"></i>
            <span className="ms-1">Attach</span>
          </span>
        ),
        text: `Option to add files(Max 2 files with allowed extension as .pdf, .jpg, .jpeg, .png- max 5 MB each)`,
      },
    ];

    return (
      <div
        className="d-flex flex-wrap align-items-center gap-3 mt-2"
        style={{ fontSize: "0.75rem", color: "#6b7280" }}
      >
        {legend.map((item, index) => (
          <span key={index} className="d-flex align-items-center gap-1">
            {item.sample}
            {item.text}
          </span>
        ))}
      </div>
    );
  }

  renderAttachmentModal() {
    const {
      showAttachmentModal,
      activeAttachmentKey,
      activeAttachmentTitle,
      attachmentDetails,
    } = this.state;

    const attachments = attachmentDetails[activeAttachmentKey] || [];
    // A readonly plan still takes files. The lock is there to freeze the agreed
    // timings, and an attachment is a document against a deliverable, not a
    // change to one - everyone working this plan can add and remove them
    const canAdd = attachments.length < MAX_ATTACHMENTS;
    const hasPending = this.hasPendingAttachments();

    return (
      <Modal
        isOpen={showAttachmentModal}
        onRequestClose={this.closeAttachmentModal}
        ariaHideApp={false}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 text-white">
              <h6 className="mb-0">Attachments</h6>
              <button
                type="button"
                className="btn-close ms-auto"
                onClick={this.closeAttachmentModal}
              ></button>
            </div>

            <div className="modal-body" style={{ background: "#f9fafb" }}>
              {activeAttachmentTitle && (
                <p className="text-muted small mb-3">{activeAttachmentTitle}</p>
              )}

              {attachments.length > 0 ? (
                attachments.map((attachment, index) => (
                  <div
                    key={attachment.ExhPlanAttachmentDtlID || attachment.id || index}
                    className="d-flex align-items-center justify-content-between bg-white border rounded p-2 mb-2"
                  >
                    <div className="d-flex flex-column text-break">
                      <div className="d-flex align-items-center gap-2">
                        <i className="ri-file-line"></i>
                        <span style={{ fontSize: 14 }}>
                          {getAttachmentName(attachment)}
                        </span>
                        {attachment.isNew && (
                          <span className="text-danger small">
                            • Not saved yet
                          </span>
                        )}
                      </div>
                      {/* Anyone on this plan can upload, so the list has to say
                          who put the file there */}
                      {(attachment.UploadedByName ||
                        attachment.UploadedDate) && (
                          <span style={{ fontSize: 12, color: "#6b7280" }}>
                            {attachment.UploadedByName || "-"}
                            {attachment.UploadedDate
                              ? ` • ${formatServerDateTime(
                                attachment.UploadedDate
                              )}`
                              : ""}
                          </span>
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-aqua-border"
                        onClick={() =>
                          window.open(
                            getAttachmentUrl(attachment.AttachmentFilePath),
                            "_blank"
                          )
                        }
                        title="View"
                      >
                        <i className="ri-eye-line"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-aqua"
                        onClick={() => this.removeAttachment(index)}
                        title="Remove"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-left">No attachment added</div>
              )}

              <p className="text-muted small mt-3 mb-0">
                Up to {MAX_ATTACHMENTS} attachments (.pdf, .jpg, .jpeg, .png -
                max 5 MB each). Remove one to add another.
                <br />
                Everyone working this plan sees the same files.
                <br />
                Submit to store the changes, or leave them to go with the next
                plan save.
              </p>
            </div>

            <div className="modal-footer p-2 d-block">
              <div className="d-flex align-items-center justify-content-end gap-2">
                {canAdd && (
                  <label
                    className="btn btn-aqua mb-0"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="ri-upload-2-line me-1"></i>
                    Upload
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      hidden
                      onChange={this.handleAttachmentPick}
                    />
                  </label>
                )}
                <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={this.saveAttachments}
                  disabled={!hasPending}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={this.closeAttachmentModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  addNewDeliverable = () => {
    const { grid, halls } = this.state;
    const newRow = { service: "", isNewService: true };

    halls.forEach((hall) => {
      // Calculate max Srno for this hall across all services
      let maxSrno = 0;
      let hallId = null;

      grid.forEach((row) => {
        if (Array.isArray(row[hall])) {
          row[hall].forEach((vendor) => {
            if (vendor.Srno > maxSrno) {
              maxSrno = vendor.Srno;
            }
            if (vendor.HallID && !hallId) {
              hallId = vendor.HallID;
            }
          });
        }
      });

      newRow[hall] = {
        StartTime: null,
        EndTime: null,
        vendors: [
          {
            ExhVendorPlanDtlID: `new_${Date.now()}_${Math.random()}`,
            Srno: maxSrno + 1,
            HallID: hallId,
            WorkOrderDeliverablesID: null,
            DeliverablesServiceName: "",
            IsCompleted: false,
            DeliverableText: "",
            isNew: true,
          },
        ]
      };
    });

    this.setState({ grid: [...grid, newRow] }, () => {
      setTimeout(() => {
        const textareas = document.querySelectorAll('.deliverable-services textarea');
        const lastTextarea = textareas[textareas.length - 1];
        if (lastTextarea) {
          lastTextarea.focus();
        }
      }, 100);
    });
  };

  updateServiceName = (rowIndex, newServiceName) => {
    const { grid } = this.state;
    const updatedGrid = [...grid];
    updatedGrid[rowIndex].service = newServiceName;

    // Update DeliverablesServiceName for all vendors in this row
    Object.keys(updatedGrid[rowIndex]).forEach((hall) => {
      if (updatedGrid[rowIndex][hall]?.vendors) {
        updatedGrid[rowIndex][hall].vendors.forEach((vendor) => {
          vendor.DeliverablesServiceName = newServiceName;
        });
      }
    });

    this.setState({ grid: updatedGrid });
  };

  handleUpdate = () => {
    this.setState({ showConfirmModal: true, pendingAction: 'submit' });
  };

  handleApprove = () => {
    this.setState({ showConfirmModal: true, pendingAction: 'approve' });
  };

  handleSaveAsDraft = () => {
    this.setState({ showConfirmModal: true, pendingAction: 'draft' });
  };

  confirmSubmit = () => {
    const { pendingAction } = this.state;
    const userRole = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;

    this.setState({ showConfirmModal: false });

    if (pendingAction === 'submit') {
      const isAdmin = userRole == 6 ? 1 : 0;
      this.submitPlan(0, 0, "Plan Submitted Successfully!", isAdmin);
    } else if (pendingAction === 'approve') {
      this.submitPlan(1, 0, "Plan Approved Successfully!", 1);
    } else if (pendingAction === 'draft') {
      const isAdmin = userRole == 6 ? 1 : 0;
      this.submitPlan(0, 1, "Plan Saved As Draft Successfully!", isAdmin);
    }
  };

  // Builds exactly what the API expects for the whole plan. Both the plan save
  // and a remark save go through this, so the payload never differs between them.
  // A remark save leaves the attachments out - they are stored with the plan, and
  // sending an add twice would store the same file twice
  buildPlanPayload = ({ includeAttachments = true } = {}) => {
    const { grid, halls, subPointDetails, originalSubPoints } = this.state;
    const planDetails = [];
    const subPointsArray = [];
    let validationError = "";

    // Extract plan details from grid and validate
    grid.forEach((row, rowIndex) => {
      // First vendor of each hall - used to link that hall's sub-point timings
      const hallVendorMap = {};

      // A remark belongs to the deliverable, not to a hall, so it rides on the
      // first detail row only - otherwise it would be stored once per hall
      const deliverableRemark = this.getPendingRemarkText(rowIndex);
      let deliverableRemarkSent = false;

      Object.keys(row).forEach((hall) => {
        const hallData = row[hall];
        if (hallData?.vendors) {
          if (hallData.vendors.length > 0) {
            hallVendorMap[hall] = hallData.vendors[0];
          }

          // Validate start and end date dependency at hall level
          if (
            (hallData.StartTime && !hallData.EndTime) ||
            (!hallData.StartTime && hallData.EndTime)
          ) {
            validationError =
              "If Start Date Time is provided, End Date Time must also be filled and vice versa.";
          }

          // Validate end date cannot be less than start date
          if (hallData.StartTime && hallData.EndTime) {
            const startDate = new Date(hallData.StartTime);
            const endDate = new Date(hallData.EndTime);
            if (endDate < startDate) {
              validationError =
                "End date and time cannot be earlier than the start date and time";
            }
          }

          hallData.vendors.forEach((vendor) => {
            const rowRemark = deliverableRemarkSent ? null : deliverableRemark;
            if (rowRemark) deliverableRemarkSent = true;

            planDetails.push({
              ExhVendorPlanDtlID: vendor.isNew
                ? null
                : vendor.ExhVendorPlanDtlID,
              Srno: vendor.Srno,
              HallID: vendor.HallID,
              WorkOrderDeliverablesID: vendor.WorkOrderDeliverablesID,
              DeliverablesServiceName: vendor.DeliverablesServiceName,
              StartTime: hallData.StartTime
                ? moment(hallData.StartTime)
                  .utcOffset("+05:30")
                  .format("YYYY-MM-DD HH:mm")
                : null,
              EndTime: hallData.EndTime
                ? moment(hallData.EndTime)
                  .utcOffset("+05:30")
                  .format("YYYY-MM-DD HH:mm")
                : null,
              IsCompleted: vendor.IsCompleted,
              DeliverableText: vendor.DeliverableText || "",
              Remark: rowRemark,
              IsRemarkAdd: !!rowRemark,
              isNew: vendor.isNew || false,
            });
          });
        }
      });

      // Collect current sub-points for this deliverable
      const subPointKey = `row_${rowIndex}`;
      if (subPointDetails[subPointKey]) {
        subPointDetails[subPointKey].forEach((subPoint, subIndex) => {
          const seqNo = `${rowIndex + 1}.${subIndex + 1}`;

          // Same as the deliverable remark - one copy for the whole sub point
          const subPointRemark = this.getPendingRemarkText(rowIndex, subPoint.id);
          let subPointRemarkSent = false;

          // One entry per hall so every hall column keeps its own timings
          halls.forEach((hall) => {
            const times = subPoint.times?.[hall] || {};
            const vendor = hallVendorMap[hall];

            if (
              (times.StartTime && !times.EndTime) ||
              (!times.StartTime && times.EndTime)
            ) {
              validationError = `${seqNo}: If Start Date Time is provided, End Date Time must also be filled and vice versa.`;
            }

            if (times.StartTime && times.EndTime) {
              if (new Date(times.EndTime) < new Date(times.StartTime)) {
                validationError = `${seqNo}: End date and time cannot be earlier than the start date and time`;
              }
            }

            // A sub point has to stay within its deliverable timings for that hall
            const parentTimes = row[hall] || {};
            const parentStart = parentTimes.StartTime
              ? new Date(parentTimes.StartTime)
              : null;
            const parentEnd = parentTimes.EndTime
              ? new Date(parentTimes.EndTime)
              : null;

            // Timings are optional, the range is only checked for whatever is filled
            if (parentStart || parentEnd) {
              const parentNo = `${rowIndex + 1}`;
              const subStart = times.StartTime ? new Date(times.StartTime) : null;
              const subEnd = times.EndTime ? new Date(times.EndTime) : null;

              if (subStart && parentStart && subStart < parentStart) {
                validationError = `${seqNo} (${hall}): Start date time cannot be before the start date time of ${parentNo}`;
              } else if (subStart && parentEnd && subStart > parentEnd) {
                validationError = `${seqNo} (${hall}): Start date time cannot be after the end date time of ${parentNo}`;
              } else if (subEnd && parentEnd && subEnd > parentEnd) {
                validationError = `${seqNo} (${hall}): End date time cannot be after the end date time of ${parentNo}`;
              } else if (subEnd && parentStart && subEnd < parentStart) {
                validationError = `${seqNo} (${hall}): End date time cannot be before the start date time of ${parentNo}`;
              }
            }

            const hallRemark = subPointRemarkSent ? null : subPointRemark;
            if (hallRemark) subPointRemarkSent = true;

            subPointsArray.push({
              ExhVendorPointDtlID: times.ExhVendorPointDtlID || null,
              ExhVendorPlanDtlID: vendor?.isNew
                ? null
                : vendor?.ExhVendorPlanDtlID || null,
              WorkOrderDeliverablesID: vendor?.WorkOrderDeliverablesID || null,
              SubPoint: subPoint.SubPoint,
              StartDateTime: times.StartTime
                ? moment(times.StartTime)
                  .utcOffset("+05:30")
                  .format("YYYY-MM-DD HH:mm")
                : null,
              EndDateTime: times.EndTime
                ? moment(times.EndTime)
                  .utcOffset("+05:30")
                  .format("YYYY-MM-DD HH:mm")
                : null,
              Remark: hallRemark,
              IsRemarkAdd: !!hallRemark,
              isDeleted: false,
            });
          });
        });
      }

      // Find deleted sub-points (those in original but not in current)
      if (originalSubPoints[subPointKey]) {
        originalSubPoints[subPointKey].forEach((originalSubPoint) => {
          const stillExists = subPointDetails[subPointKey]?.some(
            (current) => current.id === originalSubPoint.id && current.SubPoint === originalSubPoint.SubPoint
          );

          if (!stillExists) {
            // This sub-point was deleted - remove it from every hall
            const deletedHalls = Object.keys(originalSubPoint.times || {});
            const targetHalls = deletedHalls.length > 0 ? deletedHalls : halls;

            targetHalls.forEach((hall) => {
              const vendor = hallVendorMap[hall];
              subPointsArray.push({
                ExhVendorPointDtlID:
                  originalSubPoint.times?.[hall]?.ExhVendorPointDtlID ||
                  originalSubPoint.ExhVendorPointDtlID ||
                  null,
                ExhVendorPlanDtlID: vendor?.isNew
                  ? null
                  : vendor?.ExhVendorPlanDtlID || null,
                WorkOrderDeliverablesID: vendor?.WorkOrderDeliverablesID || null,
                SubPoint: originalSubPoint.SubPoint,
                StartDateTime: null,
                EndDateTime: null,
                Remark: null,
                IsRemarkAdd: false,
                isDeleted: true,
              });
            });
          }
        });
      }
    });

    const ExhVendorHdrID =
      this.state.ExhVendorPlanHdrID ||
      this.props.vendorPlanDetails[0]?.ExhVendorPlanHdrID;
    const ExhibitionID = sessionStorage.getItem("sessionExhibitionID");

    const attachmentsArray = includeAttachments
      ? this.getAttachmentDetailsForSubmit()
      : [];

    return {
      planDetails,
      subPointsArray,
      attachmentsArray,
      validationError,
      ExhVendorHdrID,
      ExhibitionID,
    };
  };

  submitPlan = (IsApproved, IsSaveAsDraft, successMessage, isAdmin = 0) => {
    const {
      planDetails,
      subPointsArray,
      attachmentsArray,
      validationError,
      ExhVendorHdrID,
      ExhibitionID,
    } = this.buildPlanPayload();

    if (validationError) {
      toastError(validationError);
      return;
    }

    if (!ExhVendorHdrID) {
      toastError("Service Partner Plan ID not found!");
      return;
    }

    this.setState({ isLoading: true });

    this.props
      .updateVendorPlan_action(
        ExhVendorHdrID,
        ExhibitionID,
        IsApproved,
        IsSaveAsDraft,
        planDetails,
        subPointsArray,
        attachmentsArray,
        isAdmin
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(successMessage);
          if (this.props.onNavigateBack) {
            this.props.onNavigateBack();
          } else {
            this.props.navigate("/vendorPlan");
          }
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  // Keeps a time slot selectable only while it stays inside the parent range.
  // The picker builds its time list on the selected day, so time already
  // carries the right date
  isTimeWithinBounds(time, minBound, maxBound) {
    if (!minBound && !maxBound) return true;

    const candidate = new Date(time);
    if (minBound && candidate < new Date(minBound)) return false;
    if (maxBound && candidate > new Date(maxBound)) return false;
    return true;
  }

  // Shared Start/End Date Time pair - used by both deliverable and sub point rows.
  // minBound/maxBound carry the parent deliverable timings for sub point rows
  renderTimePair({ start, end, onChange, onCalendarClose, onValidate, disabled, minBound, maxBound }) {
    // With a parent range the range itself drives the limits, the current
    // date time rule no longer applies (a parent range can be in the past)
    const isBounded = !!(minBound || maxBound);

    // Picking a day carries over the previous time, so pull anything that
    // lands outside the parent range back to the nearest allowed value
    const clampToBounds = (date) => {
      if (!date || !isBounded) return date;
      const picked = new Date(date);
      if (minBound && picked < new Date(minBound)) return new Date(minBound);
      if (maxBound && picked > new Date(maxBound)) return new Date(maxBound);
      return picked;
    };

    return (
      <div className="row">
        <div className="col-6">
          <label className="form-label small mb-1 p-0 m-0">Start Date Time</label>
          <DatePicker
            selected={start && moment(start).isValid() ? moment(start).toDate() : null}
            dateFormat="dd/MM/yyyy HH:mm"
            timeFormat="HH:mm"
            showTimeSelect
            timeIntervals={5}
            className="form-control form-control-sm w-100"
            onChange={(date) => onChange("StartTime", clampToBounds(date))}
            onCalendarClose={() => {
              if (start) {
                onCalendarClose("StartTime", start);
              }
            }}
            onBlur={() => onValidate("StartTime")}
            minDate={minBound ? new Date(minBound) : new Date()}
            maxDate={maxBound ? new Date(maxBound) : null}
            minTime={isBounded ? undefined : new Date()}
            maxTime={isBounded ? undefined : new Date().setHours(23, 59, 59, 999)}
            filterTime={(time) => {
              if (isBounded) {
                // Until a day is picked the list sits on today, so it cannot be range checked
                return start
                  ? this.isTimeWithinBounds(time, minBound, maxBound)
                  : true;
              }
              const selectedDate = start ? new Date(start) : new Date();
              const today = new Date();
              if (selectedDate.toDateString() === today.toDateString()) {
                return time.getTime() >= today.getTime();
              }
              return true;
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText="Date and Time"
            dayClassName={() => "example-datepicker-day-class"}
            popperClassName="example-datepicker-class"
            disabled={disabled}
            popperProps={{
              strategy: "fixed",
              modifiers: [{ name: "offset", options: { offset: [0, 5] } }],
            }}
          />
        </div>
        <div className="col-6">
          <label className="form-label small mb-1 p-0 m-0">End Date Time</label>
          <DatePicker
            selected={end && moment(end).isValid() ? moment(end).toDate() : null}
            dateFormat="dd/MM/yyyy HH:mm"
            timeFormat="HH:mm"
            showTimeSelect
            timeIntervals={5}
            className="form-control form-control-sm w-100"
            onChange={(date) => {
              // First pick after a start date keeps the start date, only the time changes
              if (date && start && !end) {
                const adjustedDate = new Date(start);
                adjustedDate.setHours(date.getHours(), date.getMinutes(), 0, 0);
                onChange("EndTime", clampToBounds(adjustedDate));
              } else {
                onChange("EndTime", clampToBounds(date));
              }
            }}
            onBlur={() => onValidate("EndTime")}
            onCalendarClose={() => {
              onValidate("EndTime");
              if (end) {
                onCalendarClose("EndTime", end);
              }
            }}
            minDate={
              start
                ? new Date(start)
                : minBound
                  ? new Date(minBound)
                  : null
            }
            maxDate={maxBound ? new Date(maxBound) : null}
            minTime={
              isBounded
                ? undefined
                : (() => {
                  if (!start) return new Date().setHours(0, 0, 0, 0);
                  const startDate = new Date(start);
                  const endDate = end ? new Date(end) : new Date();
                  return startDate.toDateString() === endDate.toDateString()
                    ? startDate
                    : new Date().setHours(0, 0, 0, 0);
                })()
            }
            maxTime={isBounded ? undefined : new Date().setHours(23, 59, 59, 999)}
            filterTime={(time) => {
              if (isBounded) {
                // Until a day is picked the list sits on today, so it cannot be range checked
                if (!end) return true;
                if (!this.isTimeWithinBounds(time, minBound, maxBound)) {
                  return false;
                }
                if (start) {
                  const startTime = new Date(start);
                  if (new Date(end).toDateString() === startTime.toDateString()) {
                    return time.getTime() > startTime.getTime();
                  }
                }
                return true;
              }
              if (start) {
                const startTime = new Date(start);
                const selectedDate = end ? new Date(end) : new Date(start);
                if (selectedDate.toDateString() === startTime.toDateString()) {
                  return time.getTime() > startTime.getTime();
                }
                return true;
              }
              return true;
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText="Date and Time"
            dayClassName={() => "example-datepicker-day-class"}
            popperClassName="example-datepicker-class"
            disabled={disabled}
            popperProps={{
              strategy: "fixed",
              modifiers: [{ name: "offset", options: { offset: [0, 5] } }],
            }}
          />
        </div>
      </div>
    );
  }

  // Consolidated manager list for one hall cell of one deliverable
  getHallManagers(vendors) {
    const allManagers = [];

    vendors.forEach((v) => {
      const addManager = (name, email, mobile, roles) => {
        if (!name && !email && !mobile) return;

        const existing = allManagers.find(
          (m) => m.name === name && m.email === email && m.mobile === mobile
        );

        if (existing) {
          roles.forEach((role) => {
            if (!existing.roles.includes(role)) {
              existing.roles.push(role);
            }
          });
        } else {
          allManagers.push({ name, email, mobile, roles: [...roles] });
        }
      };

      if (v.PreSetupManagerName || v.PreSetupManagerEmail || v.PreSetupManagerMobile) {
        addManager(v.PreSetupManagerName, v.PreSetupManagerEmail, v.PreSetupManagerMobile, ['Pre-Setup']);
      }
      if (v.EventDayManagerName || v.EventDayManagerEmail || v.EventDayManagerMobile) {
        addManager(v.EventDayManagerName, v.EventDayManagerEmail, v.EventDayManagerMobile, ['Event Days']);
      }
      if (v.DismantleManagerName || v.DismantleManagerEmail || v.DismantleManagerMobile) {
        addManager(v.DismantleManagerName, v.DismantleManagerEmail, v.DismantleManagerMobile, ['Dismantling']);
      }
    });

    return allManagers;
  }

  // Remark trigger - stays enabled for every role, read only or not, because
  // the plan is shared and anyone looking at it can comment
  renderRemarkButton(rowIndex, subPointId, title, className = "btn btn-sm btn-aqua-border", style = {}) {
    const count = (
      this.state.remarkDetails[this.getRemarkKey(rowIndex, subPointId)] || []
    ).length;

    return (
      <button
        type="button"
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          this.openRemarkModal(rowIndex, subPointId, title);
        }}
        style={{
          padding: "0.25rem 0.5rem",
          fontSize: "0.7rem",
          whiteSpace: "nowrap",
          ...style
        }}
        title="Notes/Remark"
      >
        <i className="ri-message-3-line"></i>
        <span className="ms-1">Notes/Remark{count > 0 ? ` (${count})` : ""}</span>
      </button>
    );
  }

  // Same chat layout as the Hall Manager work updation remark popup -
  // own messages on the right, everyone else's on the left
  // Letters and digits only, so spacing, case and punctuation differences don't
  // decide who wrote a message
  normalizeName = (value) =>
    String(value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");

  // The remark result set carries UserName but no id, so own messages are found
  // by matching that name against every identity the session can offer
  getOwnIdentities() {
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS")) || {};
    const first = loginData.FirstName || sessionStorage.getItem("firstNameSS") || "";
    const last = loginData.LastName || sessionStorage.getItem("lastNameSS") || "";

    return new Set(
      [
        loginData.UserName,
        loginData.Name,
        loginData.FullName,
        loginData.PersonName,
        loginData.EmailID,
        loginData.Email,
        sessionStorage.getItem("userEmailSS"),
        `${first} ${last}`,
        `${last} ${first}`,
      ]
        .map(this.normalizeName)
        .filter((value) => value.length > 0)
    );
  }

  // The API sends the role as "Vendor", but that party is called the Service
  // Partner everywhere on screen. Only the printed text changes - the raw value
  // still decides whose message it is
  displayDesignation = (designation) =>
    String(designation ?? "").replace(/\bvendor\b/gi, "Service Partner");

  renderRemarkThread(remarks) {
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
    const currentUserID = loginData.UserID;
    const currentRole = this.normalizeName(loginData.RoleName);
    const ownIdentities = this.getOwnIdentities();

    // Any of the three is enough. The id is exact and rides on messages added in
    // this session, the name covers what the API returns, and the signed in role
    // matched against the remark's Role catches the rest
    const isOwnRemark = (item) =>
      (item.LastUpdatedBy != null && item.LastUpdatedBy == currentUserID) ||
      ownIdentities.has(this.normalizeName(item.PersonName)) ||
      (!!currentRole && this.normalizeName(item.Designation) === currentRole);

    return (
      <div
        className="chat-box"
        ref={(el) => (this.remarkThreadRef = el)}
        style={{
          maxHeight: 400,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        {remarks.map((item, index) => {
          const isOwn = isOwnRemark(item);

          return (
            <div
              key={index}
              className={`message ${isOwn ? "outgoing" : "incoming"}`}
              style={{
                alignSelf: isOwn ? "flex-end" : "flex-start",
                maxWidth: "80%",
                textAlign: isOwn ? "right" : "left",
              }}
            >
              <div
                className="meta"
                style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}
              >
                {isOwn
                  ? "You"
                  : `${item.PersonName || "-"}${item.Designation
                    ? ` (${this.displayDesignation(item.Designation)})`
                    : ""
                  }`}{" "}
                •{" "}
                {formatServerDateTime(item.LastUpdatedDate)}
                {item.isPending && (
                  <span className="text-danger"> • Not saved yet</span>
                )}
              </div>

              <div
                className="bubble"
                style={{
                  background: isOwn ? "#e8f6f4" : "#fff",
                  borderRadius: "12px 12px 4px 12px",
                  padding: "8px 16px",
                  fontSize: 14,
                  border: "1px solid #e5e7eb",
                  whiteSpace: "pre-wrap",
                }}
              >
                {item.Remark}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // A long thread opens at the top, which hides the newest message - the one the
  // user came to read
  scrollRemarkThreadToBottom = () => {
    const thread = this.remarkThreadRef;
    if (thread) thread.scrollTop = thread.scrollHeight;
  };

  // react-modal parks focus on the dialog itself when it opens, so the box has
  // to be focused after that has happened - the timeout puts this at the end of
  // the same tick, otherwise react-modal's own focus call lands last and the
  // user has to click before typing
  onRemarkModalOpen = () => {
    setTimeout(() => {
      this.remarkInputRef?.focus();
      this.scrollRemarkThreadToBottom();
    }, 0);
  };

  renderRemarkModal() {
    const { showRemarkModal, activeRemarkKey, activeRemarkTitle, newRemark, remarkDetails } =
      this.state;

    const remarks = remarkDetails[activeRemarkKey] || [];

    // react-modal, same as the work updation remark popup - it portals out to
    // the body so the sticky plan table can't trap or cover it
    return (
      <Modal
        isOpen={showRemarkModal}
        onRequestClose={this.closeRemarkModal}
        onAfterOpen={this.onRemarkModalOpen}
        ariaHideApp={false}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 text-white">
              <h6 className="mb-0">Notes/Remark</h6>
              <button
                type="button"
                className="btn-close ms-auto"
                onClick={this.closeRemarkModal}
              ></button>
            </div>

            <div className="modal-body" style={{ background: "#f9fafb" }}>
              {activeRemarkTitle && (
                <p className="text-muted small mb-3">{activeRemarkTitle}</p>
              )}
              {remarks.length > 0 ? (
                this.renderRemarkThread(remarks)
              ) : (
                <div className="text-left">Record not found</div>
              )}

              {/* No form-control-sm here - custom.css pins that class to a
                  130px wide box, which leaves nothing to type in */}
              <div className="mt-3">
                <textarea
                  ref={(el) => (this.remarkInputRef = el)}
                  className="form-control w-100"
                  rows={3}
                  maxLength={500}
                  placeholder="Type a note/remark..."
                  value={newRemark}
                  onChange={(e) => this.setState({ newRemark: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      this.addRemark();
                    }
                  }}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px", padding: "10px 12px", borderTop: "1px solid #dee2e6", backgroundColor: "#fff" }}>
              <button
                type="button"
                className="btn btn-aqua"
                onClick={this.addRemark}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-gray"
                onClick={this.closeRemarkModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderWorkUpdationList() {
    const { halls, grid, isReadonly, subPointDetails } = this.state;

    return (
      <div
        className="table-freeze"
        style={{
          height: "calc(100vh - 205px)",
          overflow: "auto",
          padding: 0,
        }}
      >
        <table
          className="table table-bordered align-middle"
          style={{
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed",
            width: "100%",
          }}
        >
          <thead>
            <tr>
              <th
                className="text-left deliverable-services"
                style={{
                  width: "320px",
                  minWidth: "320px",
                  position: "sticky",
                  left: 0,
                  top: 0,
                  zIndex: 4,
                  backgroundColor: "#fff",
                }}
              >
                Deliverables
              </th>
              {halls.map((hall, index) => (
                <th
                  className="text-center plan-time"
                  style={{
                    width: "325px",
                    minWidth: "325px",
                    maxWidth: "325px",
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    backgroundColor: "#fff",
                  }}
                >
                  {hall}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {grid.map((row, i) => {
              const subPoints = subPointDetails[`row_${i}`] || [];
              const stickyCellStyle = {
                width: "320px",
                minWidth: "320px",
                position: "sticky",
                left: 0,
                zIndex: 2,
                backgroundColor: "#fff",
                verticalAlign: "top",
              };
              const hallCellStyle = {
                width: "325px",
                minWidth: "325px",
                maxWidth: "325px",
              };

              return (
                <Fragment key={i}>
                  {/* Deliverable row */}
                  <tr>
                    <td
                      className="text-left align-top deliverable-services"
                      style={stickyCellStyle}
                    >
                      <div className="d-flex align-items-start">
                        <span className="me-2 fw-bold">{i + 1}.</span>
                        <div className="flex-grow-1">
                          {row.isNewService ? (
                            <textarea
                              className="form-control form-control-sm w-100"
                              placeholder="Enter deliverable name"
                              value={row.service}
                              onChange={(e) =>
                                this.updateServiceName(i, e.target.value)
                              }
                              rows={2}
                              disabled={isReadonly}
                            />
                          ) : (
                            <div style={{ fontWeight: "500" }}>{row.service}</div>
                          )}
                        </div>
                      </div>

                      {/* The frozen column is a fixed width, so the two wide
                          buttons are stacked instead of left to wrap - that way
                          they share a left edge rather than one of them falling
                          back under the add button */}
                      <div className="d-flex align-items-start gap-2 mt-2">
                        {!isReadonly && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-aqua"
                            onClick={() => this.addSubPoint(i)}
                            style={{
                              padding: "0.25rem 0.5rem",
                              fontSize: "0.7rem",
                              whiteSpace: "nowrap",
                            }}
                            title="Add"
                          >
                            <i className="ri-add-line"></i>
                          </button>
                        )}
                        <div className="d-flex flex-column align-items-start gap-1">
                          {this.renderRemarkButton(
                            i,
                            null,
                            `${i + 1}. ${row.service}`
                          )}
                          {this.renderAttachmentButton(
                            i,
                            null,
                            `${i + 1}. ${row.service}`
                          )}
                        </div>
                      </div>
                    </td>

                    {halls.map((hall) => {
                      const hallData = row[hall];
                      const vendors = hallData?.vendors || [];
                      const allManagers = this.getHallManagers(vendors);

                      return (
                        <td
                          key={hall}
                          className="p-1 px-2 align-top plan-time"
                          style={hallCellStyle}
                        >
                          {vendors.length === 0 && (
                            <span className="text-gray-400 fst-italic">
                              Not Allocated
                            </span>
                          )}
                          {vendors.length > 0 && (
                            <div>
                              <div className="d-flex justify-content-end mb-1">
                                {allManagers.length > 0 && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-aqua"
                                    onClick={() =>
                                      this.openManagerModal(
                                        allManagers,
                                        hall,
                                        row.service
                                      )
                                    }
                                    style={{
                                      padding: "0.15rem 0.4rem",
                                      fontSize: "0.8rem",
                                      lineHeight: 1,
                                    }}
                                    title="View team members"
                                  >
                                    <i className="ri-information-line"></i>
                                  </button>
                                )}
                              </div>
                              {this.renderTimePair({
                                start: hallData.StartTime,
                                end: hallData.EndTime,
                                disabled: isReadonly,
                                onChange: (field, date) =>
                                  this.updateVendorTime(i, hall, field, date),
                                onValidate: (field) =>
                                  this.validateDateTime(i, hall, field),
                                onCalendarClose: (field, value) =>
                                  this.setState({
                                    ...(field === "StartTime"
                                      ? {
                                        showStartTimeModal: true,
                                        pendingStartTime: value,
                                      }
                                      : {
                                        showEndTimeModal: true,
                                        pendingEndTime: value,
                                      }),
                                    pendingRowIndex: i,
                                    pendingHallName: hall,
                                    pendingSubPointId: null,
                                  }),
                              })}
                            </div>
                          )}
                        </td>
                      );
                    })}
                  </tr>

                  {/* Sub point rows - 1.1, 1.2, ... */}
                  {subPoints.map((subPoint, si) => (
                    <tr key={subPoint.id}>
                      <td
                        className="text-left align-top deliverable-services"
                        style={stickyCellStyle}
                      >
                        <div className="d-flex align-items-start ps-3">
                          <span
                            className="me-2 small fw-bold"
                            style={{ whiteSpace: "nowrap", paddingTop: "0.35rem" }}
                          >
                            {i + 1}.{si + 1}
                          </span>
                          {/* minWidth 0 lets the cell shrink - without it the
                              widest button row sets the width and the content
                              overflows into the hall column */}
                          <div
                            className="flex-grow-1 position-relative"
                            style={{ minWidth: 0 }}
                          >
                            <textarea
                              className="form-control form-control-sm w-100"
                              data-subpoint-id={subPoint.id}
                              placeholder="Enter details"
                              value={subPoint.SubPoint}
                              onChange={(e) =>
                                this.updateSubPoint(i, subPoint.id, e.target.value)
                              }
                              rows={2}
                              disabled={isReadonly}
                              style={{ paddingRight: "2rem", fontSize: "0.85rem" }}
                            />
                            {!isReadonly && (
                              <button
                                type="button"
                                className="btn btn-sm btn-aqua position-absolute"
                                onClick={() => this.removeSubPoint(i, subPoint.id)}
                                style={{
                                  right: "0.25rem",
                                  top: "0.25rem",
                                  padding: "0.2rem 0.4rem",
                                  fontSize: "0.7rem",
                                }}
                                title="Delete"
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            )}
                            <div className="mt-1 d-flex flex-wrap align-items-center gap-2">
                              {this.renderRemarkButton(
                                i,
                                subPoint.id,
                                `${i + 1}.${si + 1} ${subPoint.SubPoint || ""}`
                              )}
                              {this.renderAttachmentButton(
                                i,
                                subPoint.id,
                                `${i + 1}.${si + 1} ${subPoint.SubPoint || ""}`
                              )}
                            </div>
                          </div>
                        </div>
                      </td>

                      {halls.map((hall) => {
                        const vendors = row[hall]?.vendors || [];
                        const times = subPoint.times?.[hall] || {};
                        // Sub point pickers are limited to the deliverable range
                        const parentStart = row[hall]?.StartTime || null;
                        const parentEnd = row[hall]?.EndTime || null;

                        return (
                          <td
                            key={hall}
                            className="p-1 px-2 align-top plan-time"
                            style={hallCellStyle}
                          >
                            {vendors.length === 0 ? (
                              <span className="text-gray-400 fst-italic">-</span>
                            ) : (
                              this.renderTimePair({
                                start: times.StartTime,
                                end: times.EndTime,
                                disabled: isReadonly,
                                minBound: parentStart,
                                maxBound: parentEnd,
                                onChange: (field, date) =>
                                  this.updateSubPointTime(
                                    i,
                                    subPoint.id,
                                    hall,
                                    field,
                                    date
                                  ),
                                onValidate: (field) =>
                                  this.validateSubPointDateTime(
                                    i,
                                    subPoint.id,
                                    hall,
                                    field
                                  ),
                                onCalendarClose: (field, value) =>
                                  this.setState({
                                    ...(field === "StartTime"
                                      ? {
                                        showStartTimeModal: true,
                                        pendingStartTime: value,
                                      }
                                      : {
                                        showEndTimeModal: true,
                                        pendingEndTime: value,
                                      }),
                                    pendingRowIndex: i,
                                    pendingHallName: hall,
                                    pendingSubPointId: subPoint.id,
                                  }),
                              })
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderMobileView() {
    const { halls, grid, isReadonly, expandedDeliverable, expandedHall } = this.state;

    return (
      <div className="mobile-plan-container d-block d-lg-none mt-3" style={{ paddingBottom: "50px" }}>
        {grid.map((row, i) => {
          const isDeliverableExpanded = expandedDeliverable === i;
          return (
            <div key={i} className="card mb-1 mobile-accordion-card border-0" style={{ backgroundColor: "transparent", scrollMarginTop: "140px" }}>
              <div
                className="card-header d-block"
                style={{
                  backgroundColor: isDeliverableExpanded ? "#f0fdfa" : "#fff",
                  borderRadius: isDeliverableExpanded ? "8px 8px 0 0" : "8px",
                  border: "1px solid #e2e8f0",
                  borderLeft: "3px solid #0f6f60",
                  borderBottom: isDeliverableExpanded ? "none" : "1px solid #e2e8f0",
                  padding: "16px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  transition: "background-color 0.2s ease"
                }}
              >
                <div 
                   className="d-flex justify-content-between align-items-start w-100"
                   style={{ cursor: "pointer" }}
                   onClick={(e) => {
                     const target = e.currentTarget.parentElement.parentElement;
                     this.setState({ expandedDeliverable: isDeliverableExpanded ? null : i, expandedHall: null }, () => {
                       if (!isDeliverableExpanded) {
                         setTimeout(() => {
                           target.scrollIntoView({ behavior: "smooth", block: "start" });
                         }, 100);
                       }
                     });
                   }}
                >
                  <div className="d-flex align-items-start text-left pe-2">
                    <span className="me-2 fw-bold" style={{ color: "#0f6f60", fontSize: "16px" }}>{i + 1}.</span>
                    <span style={{ fontWeight: "400", fontSize: "15px", color: "#1e293b", flex: 1 }}>{row.service}</span>
                  </div>
                  <i className={`ri-arrow-${isDeliverableExpanded ? 'up' : 'down'}-s-line fs-5 mt-1`} style={{ color: "#0f6f60" }}></i>
                </div>
                
                <hr style={{ margin: "12px 0", borderColor: "#f1f5f9" }} />
                
                <div className="d-flex align-items-center justify-content-end gap-2 w-100 flex-wrap">
                  {this.renderRemarkButton(i, null, `${i + 1}. ${row.service}`, "btn btn-sm px-3 rounded-pill", { border: "1px solid #0f6f60", color: "#0f6f60", backgroundColor: "transparent", fontWeight: "500" })}
                  {this.renderAttachmentButton(i, null, `${i + 1}. ${row.service}`, "btn btn-sm px-3 rounded-pill", { border: "1px solid #0f6f60", color: "#0f6f60", backgroundColor: "transparent", fontWeight: "500" })}
                </div>
              </div>

              {isDeliverableExpanded && (
                <div className="card-body p-0" style={{ border: "1px solid #e2e8f0", borderTop: "1px solid #f1f5f9", borderRadius: "0 0 12px 12px", backgroundColor: "#fff" }}>
                  {halls.map((hall, hallIndex) => {
                    const hallData = row[hall];
                    const vendors = hallData?.vendors || [];
                    if (vendors.length === 0) return null; // Only show allocated halls

                    const isHallExpanded = expandedHall === hall;
                    const subPoints = this.state.subPointDetails[`row_${i}`] || [];
                    const isLastHall = hallIndex === halls.length - 1;

                    return (
                      <div key={hall} className="hall-accordion-item" style={{ borderBottom: isLastHall ? "none" : "1px solid #ddd" }}>
                        <div
                          className="p-3 d-flex justify-content-between align-items-center"
                          style={{
                            backgroundColor: isHallExpanded ? "#f0fdfa" : "#fff",
                            cursor: "pointer",
                            borderRadius: isLastHall && !isHallExpanded ? "0 0 12px 12px" : "0",
                            transition: "background-color 0.2s ease"
                          }}
                          onClick={() => this.setState({ expandedHall: isHallExpanded ? null : hall })}
                        >
                          <div className="d-flex flex-column text-left">
                            <span style={{ fontWeight: "600", fontSize: "14px", color: "#334155" }}>{hall}</span>
                            <span style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
                              {hallData.StartTime && hallData.EndTime
                                ? `${moment(hallData.StartTime).format("DD MMM, HH:mm")} - ${moment(hallData.EndTime).format("DD MMM, HH:mm")}`
                                : "Not Scheduled"}
                            </span>
                          </div>
                          <i className={`ri-${isHallExpanded ? 'subtract' : 'add'}-line fs-5`} style={{ color: "var(--primary)" }}></i>
                        </div>

                        {isHallExpanded && (
                          <div className="p-3 bg-white">
                            <div className="mb-3">
                              {this.renderTimePair({
                                start: hallData.StartTime,
                                end: hallData.EndTime,
                                disabled: isReadonly,
                                onChange: (field, date) => this.updateVendorTime(i, hall, field, date),
                                onValidate: (field) => this.validateDateTime(i, hall, field),
                                onCalendarClose: (field, value) => this.setState({
                                  ...(field === "StartTime" ? { showStartTimeModal: true, pendingStartTime: value } : { showEndTimeModal: true, pendingEndTime: value }),
                                  pendingRowIndex: i,
                                  pendingHallName: hall,
                                  pendingSubPointId: null,
                                }),
                              })}
                            </div>

                            <div className="mb-3 mt-2">
                              <label className="form-label mb-1 p-0 m-0" style={{ fontSize: "14px", color: "#334155" }}>Notes (Optional)</label>
                              <textarea
                                className="form-control w-100"
                                rows="3"
                                placeholder="Add notes here..."
                                disabled={isReadonly}
                                style={{ fontSize: "14px", padding: "12px", minHeight: "80px", borderRadius: "8px", border: "1px solid #ced4da" }}
                                value={vendors[0]?.DeliverableText || ""}
                                onChange={(e) => {
                                  const updatedGrid = [...this.state.grid];
                                  updatedGrid[i][hall].vendors.forEach(v => v.DeliverableText = e.target.value);
                                  this.setState({ grid: updatedGrid });
                                }}
                              ></textarea>
                            </div>

                            {subPoints.map((subPoint, si) => {
                              const times = subPoint.times?.[hall] || {};
                              const parentStart = row[hall]?.StartTime || null;
                              const parentEnd = row[hall]?.EndTime || null;
                              return (
                                <div key={subPoint.id} className="mb-3 p-3 bg-white d-block" style={{ border: "1px solid #e2e8f0", borderLeft: "3px solid #0f6f60", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                                  <div className="mb-2 d-flex align-items-start gap-2 text-left">
                                    <span className="fw-bold" style={{ fontSize: "15px", color: "#0f6f60" }}>{i + 1}.{si + 1}</span>
                                    <span className="text-secondary text-break" style={{ fontSize: "15px", color: "#1e293b", flex: 1 }}>{subPoint.SubPoint}</span>
                                  </div>
                                  <hr style={{ margin: "12px 0", borderColor: "#f1f5f9" }} />
                                  <div className="d-flex align-items-center justify-content-end gap-2 w-100 flex-wrap">
                                    {this.renderRemarkButton(i, subPoint.id, `${i + 1}.${si + 1} ${subPoint.SubPoint || ""}`, "btn btn-sm px-3 rounded-pill", { border: "1px solid #0f6f60", color: "#0f6f60", backgroundColor: "transparent", fontWeight: "500" })}
                                    {this.renderAttachmentButton(i, subPoint.id, `${i + 1}.${si + 1} ${subPoint.SubPoint || ""}`, "btn btn-sm px-3 rounded-pill", { border: "1px solid #0f6f60", color: "#0f6f60", backgroundColor: "transparent", fontWeight: "500" })}
                                  </div>
                                  {this.renderTimePair({
                                    start: times.StartTime,
                                    end: times.EndTime,
                                    disabled: isReadonly,
                                    minBound: parentStart,
                                    maxBound: parentEnd,
                                    onChange: (field, date) => this.updateSubPointTime(i, subPoint.id, hall, field, date),
                                    onValidate: (field) => this.validateSubPointDateTime(i, subPoint.id, hall, field),
                                    onCalendarClose: (field, value) => this.setState({
                                      ...(field === "StartTime" ? { showStartTimeModal: true, pendingStartTime: value } : { showEndTimeModal: true, pendingEndTime: value }),
                                      pendingRowIndex: i,
                                      pendingHallName: hall,
                                      pendingSubPointId: subPoint.id,
                                    }),
                                  })}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}

        {expandedHall && !isReadonly && (
          <div className="position-fixed bottom-0 start-0 end-0 bg-white shadow-lg d-block d-lg-none" style={{ zIndex: 1050, borderTop: "1px solid #e2e8f0", padding: "16px 16px 40px 16px" }}>
            <button type="button" className="btn btn-aqua w-100 py-2 fs-5 fw-bold" style={{ borderRadius: "8px" }} onClick={() => this.setState({ expandedHall: null })}>
              Save
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      isLoading,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
      isVendor,
      halls,
      grid,
      isReadonly,
      workOrderNo,
      serviceName,
      showConfirmModal,
      pendingAction,
    } = this.state;
    const userRole = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;
    const isAdmin = userRole == 6;
    const isVendorUser = userRole == 7;
    const planSubmissionDate = this.formatSubmissionDate(
      this.state.PlanSubmissionDate
    );

    const renderContent = () => (
      <>
        {/* <div class="row m-0">
          <div class="tab-scroll-fixed">
            <p>
              Plan & Timeline for {this.state.workOrderNo}
              {""} |{""} {this.state.serviceName}
            </p>
          </div>
        </div> */}

        <div className={`main-content ${(RoleID == 7 || RoleID == 17) ? "vendor-top-space" : RoleID == 6 ? "dalrout-top-space" : ""}`}>
          {/* {!isReadonly && ( */}
          <div class="row m-0">
            <div
              className="d-flex justify-content-between align-items-center mt-3"
              style={{ width: "100%" }}
            >
              <h6 className="m-0">
                Plan & Timeline for {this.state.CompanyName} |{" "}
                {this.state.serviceName}
                {planSubmissionDate && (
                  <>
                    {" | "}
                    <span className="text-danger fw-bold">
                      Plan Submission Date : {planSubmissionDate}
                    </span>
                  </>
                )}
              </h6>

              {userRole == 6 && (
                <button
                  type="button"
                  className="btn btn-aqua mt-2"
                  onClick={this.addNewDeliverable}
                >
                  Add Deliverable
                </button>
              )}
            </div>

            {this.renderButtonLegend()}
          </div>
          {/* )} */}
          <div className="row m-0">
            {/* Mobile View */}
            {halls.length > 0 ? (
              this.renderMobileView()
            ) : (
              <div className="p-3 d-block d-lg-none">Plan Loading..</div>
            )}

            {/* Desktop View */}
            <div className="mt-2 d-none d-lg-block">
              {halls.length > 0 ? (
                this.renderWorkUpdationList()
              ) : (
                <div className="p-3">Plan Loading..</div>
              )}
            </div>

            <div className="mt-2 w-100 float-left" style={{ paddingBottom: "60px" }}>
              <div
                className="d-flex flex-wrap justify-content-end gap-2 mt-0"
                style={{ marginBottom: "10px", padding: "0 15px" }}
              >
                {!isReadonly &&
                  (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                    7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) && (
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleSaveAsDraft}
                    >
                      Save as Draft
                    </button>
                  )}
                {!isReadonly &&
                  (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                    7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) && (
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleUpdate}
                    >
                      Submit
                    </button>
                  )}
                {!isReadonly &&
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  6 && (
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleUpdate}
                    >
                      Update
                    </button>
                  )}
                {!isReadonly &&
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  6 && (
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleApprove}
                    >
                      Approve
                    </button>
                  )}
                <button
                  type="button"
                  className="btn btn-gray py-1"
                  onClick={this.handleCancel}
                >
                  {isReadonly ? "Back" : "Back"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isAdmin ? (
          <>
            <HeaderWithLogo />
            <div className="app-content with-dr-container com-height">
              {renderContent()}
            </div>
            <AdminDrawer />
            <Footerwithdr />
          </>
        ) : isVendorUser ? (
          <>
            <HeaderWithLogo />
            <div className="app-content com-height mt-0">{renderContent()}</div>
            <VendorDrawer />
            {/* <Footerwithdr /> */}
          </>
        ) : (
          renderContent()
        )}

        {showConfirmModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {pendingAction === 'approve' ? 'Confirm Approval' : pendingAction === 'draft' ? 'Confirm Save as Draft' : 'Confirm Submission'}
                  </h5>
                </div>
                <div className="modal-body">
                  {pendingAction === 'approve' ? (
                    <p>Are you sure you want to approve this plan?</p>
                  ) : pendingAction === 'draft' ? (
                    <p>Are you sure you want to save this plan as draft?</p>
                  ) : (
                    <>
                      <p className="mb-2">Once you submit this plan, it will be sent to the Organizer for approval.</p>
                      <p className="mb-2">If the plan is approved, the plan and timeline will be locked, and you will no longer be able to make any changes.</p>
                      <p className="mb-0">Are you sure you want to submit this plan for approval?</p>
                    </>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={this.confirmSubmit}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={() => this.setState({ showConfirmModal: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.renderRemarkModal()}

        {this.renderAttachmentModal()}

        {this.state.showStartTimeModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Apply Start Date Time</h5>
                </div>
                <div className="modal-body">
                  <p>Do you want to set the same start date time for all Hall?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={this.applyStartTimeToRow}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={this.cancelStartTimeModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showManagerModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Team Members {this.state.modalHallName ? `- ${this.state.modalHallName}` : ""}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={this.closeManagerModal}
                  ></button>
                </div>
                <div className="modal-body">
                  {this.state.modalServiceName && (
                    <p className="text-muted small mb-3">{this.state.modalServiceName}</p>
                  )}
                  {this.state.modalManagers.length > 0 ? (
                    this.state.modalManagers.map((manager, idx) => {
                      const roleLabel = manager.roles.length === 3 ? 'All Days' : manager.roles.join(', ');
                      return (
                        <div key={idx} className="card mb-2 shadow-sm border rounded-3 position-relative" style={{ borderColor: '#6c757d', borderWidth: '2px' }}>
                          <span className="badge position-absolute top-0 end-0 m-1" style={{ backgroundColor: '#2e8b82', color: 'white', fontSize: '0.65rem', borderRadius: '0.3rem', padding: '0.2rem 0.4rem' }}>
                            {roleLabel}
                          </span>
                          <div className="card-body p-2 d-flex align-items-center">
                            <div className="me-2">
                              <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: 35, height: 35 }}>
                                <i className="ri-user-3-line fs-5" />
                              </div>
                            </div>
                            <div>
                              <h6 className="mb-0 fw-bold small">{manager.name || '-'}</h6>
                              <p className="mb-0 text-muted small">
                                <i className="ri-phone-line me-1" />{manager.mobile || '-'}
                              </p>
                              <p className="mb-0 text-muted small">
                                <i className="ri-mail-line me-1" />{manager.email || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-muted small p-2">-</div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={this.closeManagerModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showEndTimeModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Apply End Date Time</h5>
                </div>
                <div className="modal-body">
                  <p>Do you want to set the same end date time for all Hall?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={this.applyEndTimeToRow}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={this.cancelEndTimeModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("Redux state:", state.getVendorPlanListReducer);
  return {
    vendorPlanDetails: state.getVendorPlanListReducer?.vendorPlanDetails || [],
  };
};

export default withRouter(
  connect(mapStateToProps, {
    fill_action,
    getVendorAuditTrackerList_action,
    updateVendorPlan_action,
    getVendorPlanDetail_action,
  })(VendorPlanRecord)
);
